import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, count } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

interface ProductRegistrationByLocationProps {
    dateRange: { startDate: string; endDate: string };
}

export const ProductRegistrationByLocation = ({ dateRange }: ProductRegistrationByLocationProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_COUNTRY,
        params: { ...dateRange },
    });

    return (
        <BaseReport
            title={'Product Registrations % Rate by Country'}
            description={'This table shows you the number of registrations you obtain as a % of total cuts, by country.'}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Country Name', 'Registration %', 'World Rank(by %)'],
                data: data.map((item) => [item.countryName, item.registrationPct, item.worldRank]),
                summaries: [count, average, count],
                sort: [basicSort, basicSort, basicSort],
            }}
        />
    );
};
